// The organisation's text size zooms the app shell only (menus and dialogs, rendered outside it, keep correct positions).
export const applyZoom = (z) => {
  document.documentElement.style.setProperty("--sv-zoom", String(z));
};
